<template>
  <div class="md-layout text-center">
    <h1 class="dashboard-title">Welcome to the Admin Dashboard</h1>

    <!-- Statistics Section -->
    <!--<div class="stats-container">
      <div class="stat-card" v-for="(stat, index) in stats" :key="index">
        <h3 class="stat-title">{{ stat.title }}</h3>
        <p class="stat-value">{{ stat.value }}</p>
      </div>
    </div>-->

    <!-- Applications and Categories Section -->
    <!--<div class="usage-container">
      <div class="usage-card">
        <h3>Most Used Apps Today</h3>
        <ul>
          <li v-for="(app, index) in mostUsedAppsToday" :key="index" class="app-item">
            <span :style="{ color: app.iconColor }" class="app-icon">🔲</span> 
            <span class="app-text">{{ app.name }} - <span class="usage-highlight">{{ app.usageCount }} minutes</span></span>
          </li>
        </ul>
      </div>

      <div class="category-usage-card">
        <h3>Most Used Categories Today</h3>
        <ul>
          <li v-for="(category, index) in mostUsedCategoriesToday" :key="index">
            {{ category.name }} - <span class="usage-highlight">{{ category.usageCount }} minutes</span>
          </li>
        </ul>
      </div>
    </div>-->

    <!-- Top Used Apps and Categories Section -->
    <!--<div class="top-used-container">
      <div class="top-app-card">
        <h3>Top Used Apps This Week</h3>
        <ul>
          <li v-for="(app, index) in topUsedAppsWeek" :key="index" class="app-item">
            <span :style="{ color: app.iconColor }" class="app-icon">🔲</span>
            <span class="app-text">{{ app.name }} - <span class="usage-highlight">{{ app.usageCount }} minutes</span></span>
          </li>
        </ul>
      </div>

      <div class="top-category-card">
        <h3>Top Used Categories This Week</h3>
        <ul>
          <li v-for="(category, index) in topUsedCategoriesWeek" :key="index">
            {{ category.name }} - <span class="usage-highlight">{{ category.usageCount }} minutes</span>
          </li>
        </ul>
      </div>
    </div>-->
  </div>
</template>

<script>
export default {
  data() {
    return {
      stats: [
        { title: "Today's Installed Apps", value: 120 },
        { title: "Today's App Usages", value: 450 },
        { title: "Today's Disabled Apps", value: 5 },
        { title: "Most Used Apps Today", value: 30 },
        { title: "Most Used Categories Today", value: 15 },
      ],
      mostUsedAppsToday: [
        { name: "Snapchat", usageCount: 50, iconColor: "#FFFC00" },
        { name: "WhatsApp Messenger", usageCount: 40, iconColor: "#25D366" },
        { name: "Instagram", usageCount: 35, iconColor: "#E4405F" },
      ],
      mostUsedCategoriesToday: [
        { name: "Social", usageCount: 80 },
        { name: "Games", usageCount: 70 },
        { name: "Productivity", usageCount: 50 },
      ],
      topUsedAppsWeek: [
        { name: "Snapchat", usageCount: 200, iconColor: "#FFFC00" },
        { name: "WhatsApp", usageCount: 180, iconColor: "#25D366" },
        { name: "Instagram", usageCount: 150, iconColor: "#E4405F" },
      ],
      topUsedCategoriesWeek: [
        { name: "Social", usageCount: 350 },
        { name: "Games", usageCount: 320 },
        { name: "Entertainment", usageCount: 290 },
      ],
    };
  },
};
</script>

<style scoped>
.md-layout {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.dashboard-title {
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #333;
}

/* Top Stats Section */
.stats-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 40px;
  width: 100%;
  max-width: 1200px;
}

.stat-card {
  background-color: #ffffff;
  padding: 15px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  text-align: center;
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.stat-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #666;
}

.stat-value {
  font-size: 24px;
  font-weight: 700;
  color: #333;
}

/* Apps and Categories Layout */
.usage-container, .top-used-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  width: 100%;
  max-width: 1200px;
  margin-bottom: 40px;
}

.usage-card, .category-usage-card, .top-app-card, .top-category-card {
  background-color: #ffffff;
  padding: 15px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

h3 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #333;
}

ul {
  list-style-type: none;
  padding-left: 0;
  margin: 0;
}

li {
  font-size: 16px;
  color: #555;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}

.app-icon {
  margin-right: 10px;
  font-size: 20px;
}

.app-text {
  display: flex;
  align-items: center;
}

.usage-highlight {
  font-weight: 700;   /* Bold usage count */
  font-size: 18px;    /* Make it slightly larger */
  color: #4CAF50;     /* Highlight color (green) */
  background-color: #e8f5e9; /* Light green background */
  padding: 3px 6px;   /* Some padding for better readability */
  border-radius: 4px; /* Rounded corners */
}
</style>
